import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { createCar } from '../../actions/car'
import { notificate } from '../../actions/notification'
import { CarForm } from '../'
import { carValidator } from '../../validators'
import { links } from '../../utils'

class CarAdd extends Component {
  state = {
    errors: {}
  };

  componentDidUpdate () {
    const { redirect } = this.props.car
    if (redirect) {
      return this.props.history.push(redirect)
    }
  };

  render () {
    const { errors } = this.state
    const { sending } = this.props.car

    return (
      <div className="main-content">
        <header className="main-content__header">
          <h1 className="main-content__title">Adicionar carro</h1>
          <Link to={links.get('home')} className="main-content__cancel">Voltar</Link>
        </header>
        <CarForm
          sending={sending}
          errors={errors}
          onSubmit={this._handleSubmit}
        />
      </div>
    )
  };

  _handleSubmit = data => {
    const errors = {}
    this.setState({ errors }, () => {
      carValidator.create(data).then(result => {
        if (result.success) {
          const { token } = this.props
          this.props.createCar(data, token)
        } else {
          this.setState({ errors: result.errors })
        }
      }).catch(error => {
        this.props.notificate(error.message)
      })
    })
  };
}

const mapStateToProps = (state) => {
  return {
    token: state.user.user.token,
    car: state.car
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createCar: (data, token) => dispatch(createCar(data, token)),
    notificate: message => dispatch(notificate(message))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CarAdd)
